/* global Vue, useOffers */

import { messagesSpecific } from '../i18n/translations'
import { CreateI18n } from '../i18n/create-i18n'
import OfferSlider from './components/OfferSlider'

const i18n = CreateI18n(messagesSpecific)
const appElement = document.getElementById('offer-slider-app')
let sliderType = ''
let property = ''
let propertyName = ''
// const brand = ''
let holidayType = ''

const OfferSliderApp = Vue.createApp({
  name: 'OfferSliderApp',
  components: { OfferSlider },
  template: `
<div v-if="error" class="error container">
  <h3>{{ $t('error') }}</h3>
  <p>{{ error }}</p>
</div>

<div v-else-if="offersLoaded">
  <OfferSlider :offers="offers" variant="landing" />
</div>
  `,
  setup () {
    const offers = Vue.ref([])
    const offersLoaded = Vue.ref(false)
    const error = Vue.ref('')

    async function getOffers () {
      const allOffers = await useOffers({ isList: true })

      if (sliderType === 'home') {
        offers.value = allOffers.filter(offer => !!offer.showOnHome)
      } else if (sliderType === 'bundle') {
        offers.value = allOffers.filter(offer =>
          offer.variations && offer.variations.some(
            variation => variation.bundle === property))
      } else if (sliderType === 'property') {
        offers.value = allOffers.filter(offer =>
          offer.variations && offer.variations.some(
            variation => variation.property === `${property}/_index`))
        if (holidayType) {
          offers.value = offers.value.filter(offer =>
            offer.holidayTypes?.includes(holidayType))
        }
      } else {
        offers.value = allOffers.slice(0, 6)
      }

      if (property) {
        offers.value = offers.value.map(offer => ({ ...offer, link: `${offer.link}?properties=${property}` }))
      }

      if (offers.value.length === 0) {
        appElement.parentElement.remove()
      }

      // TODO: cleanup and obtain recommended offer from algolia
      if (offers.value.length > 0) {
        offers.value[0].recommended = true
      }

      offersLoaded.value = true
    }

    Vue.onMounted(async () => {
      getOffers()
    })

    return {
      offers,
      offersLoaded,
      error,
    }
  },
})

if (appElement) {
  sliderType = appElement.dataset.type
  // brand = appElement.dataset.brand
  property = appElement.dataset.property
  propertyName = appElement.dataset.propertyname
  holidayType = appElement.dataset.holidaytype
  OfferSliderApp.use(i18n)
  OfferSliderApp.mount(appElement)
}
